import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import {
  Button, MenuItem, FormGroup, NumericInput, Checkbox,
} from '@blueprintjs/core';
import { DateRangeInput, TimePrecision } from '@blueprintjs/datetime';
import { Select } from '@blueprintjs/select';
import { LazyLog } from 'react-lazylog';
import axios from 'axios';
import qs from 'query-string';

const defaultRenderer = o => (o ? (o.name || o.label || o) : o);
const defaultFilter = (query, item) => defaultRenderer(item)
  .toLowerCase()
  .indexOf(query.toLowerCase()) >= 0;

class Logs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().add(-10, 'minutes'),
      endDate: moment(),
      log: 'range',
      unit: 'nvr-ai',
      lines: 500,
      rand: Math.floor(Math.random() * 10000),
      output: 'cat',
      follow: false,
      stream: false,
      serviceStart: null,
      systemStart: null,
    };
  }

  componentDidMount() {
    this.updateUptime();
  }

  componentDidUpdate(prevProps) {
    const { nvr } = this.props;
    if (nvr) {
      if (!prevProps.nvr || nvr.hostname !== prevProps.nvr.hostname) {
        this.updateUptime();
      }
    }
  }

  @autobind
  updateUptime() {
    const { nvr } = this.props;
    if (nvr && nvr.hostname) {
      axios.get(`https://${nvr.hostname}/nvr/v1/system/uptime`, {
        headers: { Authorization: `Bearer ${nvr.access_token}` },
      })
        .then((response) => {
          this.setState({
            serviceStart: moment().subtract(response.data.content.service_uptime_secs, 'seconds'),
            systemStart: moment().subtract(response.data.content.system_uptime_secs, 'seconds'),
          });
        });
    }
  }

  @autobind
  handleRefresh() {
    this.setState({
      rand: Math.floor(Math.random() * 10000),
      endDate: moment(),
    });
  }

  @autobind
  handleLinesChange(c) {
    this.setState({ lines: c });
  }

  @autobind
  handleFollowChange(e) {
    this.setState({ follow: e.target.checked });
  }

  @autobind
  handleStreamChange(e) {
    this.setState({ stream: e.target.checked });
  }

  @autobind
  handleUnitSelect(o) {
    this.setState({ unit: o });
  }

  @autobind
  handleRangeChange(range) {
    this.setState({
      startDate: moment(range[0]),
      endDate: moment(range[1]),
    });
  }

  @autobind
  handleLogChange(event) {
    this.setState({
      log: event.target.value,
    });
  }

  @autobind
  handleOutputChange(event) {
    this.setState({
      output: event.target.value,
    });
  }

  @autobind
  handleCreateUnit(title) {
    return title;
  }

  @autobind
  handleCreateItemRender(query, active, handleClick) {
    return (
      <MenuItem
        icon="add"
        text={`Unit "${query}"`}
        active={active}
        onClick={handleClick}
        shouldDismissPopover={false}
      />
    );
  }

  renderURL() {
    const {
      startDate, endDate, unit, lines, rand, output, follow, stream, log,
      serviceStart, systemStart,
    } = this.state;
    const {
      nvr,
    } = this.props;
    const vars = {
      unit: unit === 'all' ? undefined : unit,
      access_token: nvr.access_token,
      rand,
      output,
    };
    if (log === 'range') {
      vars.since = startDate.utc().format();
      vars.until = (follow || stream) ? undefined : endDate.utc().format();
    } else if (log === 'lines') {
      vars.lines = parseInt(lines, 10) === 0 ? 100 : lines;
    } else if (log === 'service') {
      vars.since = serviceStart.utc().format();
      if (!(follow || stream)) {
        vars.lines = parseInt(lines, 10) === 0 ? 100 : lines;
      }
    } else if (log === 'service-2m') {
      vars.since = serviceStart.subtract(2, 'minutes').utc().format();
      if (!(follow || stream)) {
        vars.lines = parseInt(lines, 10) === 0 ? 100 : lines;
      }
    } else if (log === 'boot') {
      vars.since = systemStart.utc().format();
      if (!(follow || stream)) {
        vars.lines = parseInt(lines, 10) === 0 ? 100 : lines;
      }
    } else if (log === 'boot-5m') {
      vars.since = systemStart.subtract(5, 'minutes').utc().format();
      if (!(follow || stream)) {
        vars.lines = parseInt(lines, 10) === 0 ? 100 : lines;
      }
    }

    return `https://${nvr.hostname}/nvr/v1/system/logs?${qs.stringify(vars)}`;
  }

  @autobind
  renderItem(item, { handleClick, modifiers }) {
    if (!modifiers.matchesPredicate) {
      return null;
    }

    return (
      <MenuItem
        active={modifiers.active}
        disabled={modifiers.disabled}
        key={item}
        onClick={handleClick}
        text={defaultRenderer(item)}
      />
    );
  }

  render() {
    const {
      startDate, endDate, log, unit, lines, follow, stream, output, systemStart,
      serviceStart,
    } = this.state;

    return (
      <div>
        <div className="columns" style={{ textAlign: 'right' }}>
          <div className="column">
            <FormGroup
              label="Logs"
              style={{ display: 'inline-flex', marginRight: 20 }}
            >
              <div className="bp3-select">
                <select value={log} onChange={this.handleLogChange}>
                  <option value="range">Time Range</option>
                  <option value="lines">Lines</option>
                  <option value="service" disabled={!serviceStart}>nvr-ai Start</option>
                  <option value="service-2m" disabled={!serviceStart}>nvr-ai Start - 2m</option>
                  <option value="boot" disabled={!systemStart}>Boot</option>
                  <option value="boot-5m" disabled={!systemStart}>Boot - 5m</option>
                </select>
              </div>
            </FormGroup>
            <FormGroup
              label="Output"
              style={{ display: 'inline-flex', marginRight: 20 }}
            >
              <div className="bp3-select">
                <select value={output} onChange={this.handleOutputChange}>
                  <option value="cat">cat</option>
                  <option value="short">short</option>
                </select>
              </div>
            </FormGroup>
            {log === 'range' && (
              <FormGroup
                label="Date Range"
                style={{ display: 'inline-flex', marginRight: 20 }}
              >
                <DateRangeInput
                  allowSingleDayRange
                  formatDate={date => moment(date).format('llll')}
                  onChange={this.handleRangeChange}
                  parseDate={str => moment(str)}
                  value={[startDate.toDate(), endDate.toDate()]}
                  timePrecision={TimePrecision.MINUTE}
                  timePickerProps={{
                    precision: TimePrecision.MINUTE,
                    useAmPm: true,
                    showArrowButtons: true,
                  }}
                  endInputProps={{
                    disabled: (follow || stream),
                  }}
                />
              </FormGroup>
            )}
            {['lines', 'service', 'boot', 'service-2m', 'boot-5m'].includes(log) && (
              <FormGroup
                label="Lines"
                style={{ display: 'inline-flex', marginRight: 20 }}
              >
                <NumericInput
                  onValueChange={this.handleLinesChange}
                  value={lines}
                  style={{ width: 75 }}
                  disabled={['service', 'boot', 'service-2m', 'boot-5m'].includes(log) && (follow || stream)}
                />
              </FormGroup>
            )}
            <FormGroup
              label="Stream"
              style={{ display: 'inline-flex', marginRight: 20 }}
            >
              <Checkbox
                onChange={this.handleStreamChange}
                checked={stream}
                alignIndicator="right"
              />
            </FormGroup>
            <FormGroup
              label="Follow"
              style={{ display: 'inline-flex', marginRight: 20 }}
            >
              <Checkbox
                onChange={this.handleFollowChange}
                checked={follow}
                alignIndicator="right"
              />
            </FormGroup>

            <FormGroup
              label="Systemd Unit"
              style={{ display: 'inline-flex', marginRight: 20 }}
            >
              <Select
                createNewItemFromQuery={this.handleCreateUnit}
                createNewItemRenderer={this.handleCreateItemRender}
                noResults={<MenuItem disabled text="No results." />}
                filterable
                resetOnSelect
                itemRenderer={this.renderItem}
                itemPredicate={defaultFilter}
                popoverProps={{
                  minimal: true, fill: true, popoverClassName: 'popover-sz',
                }}
                items={['all', 'nvr-ai', 'safetunnel', 'cloudflared']}
                onItemSelect={this.handleUnitSelect}
              >
                <Button
                  text={defaultRenderer(unit)}
                  rightIcon="caret-down"
                />
              </Select>
            </FormGroup>


            <FormGroup
              label={<span>&nbsp;</span>}
              style={{ display: 'inline-flex' }}
            >
              <Button icon="refresh" onClick={this.handleRefresh} disabled={follow || stream} />
            </FormGroup>
          </div>
        </div>
        <LazyLog
          url={this.renderURL()}
          height={750}
          extraLines={1}
          follow={follow}
          enableSearch
          selectableLines
          websocket={follow || stream}
        />
      </div>
    );
  }
}

Logs.propTypes = {
  nvr: PropTypes.object,
};

export default Logs;
